import type { KnownRoutingContextSource } from './data-sources'

export type RoutingContextSourceType = KnownRoutingContextSource['type']

/**
 * What the "add data source" menu needs to know about a source type.
 */
export interface RoutingContextSourceTypeInfo {
  type: RoutingContextSourceType
  friendlyType: string
  friendlyDescription: string
}

/**
 * The routing data source types.
 */
export const routingContextSourceTypes: Record<
  RoutingContextSourceType,
  RoutingContextSourceTypeInfo
> = {
  UserWorkRequestCount: {
    type: 'UserWorkRequestCount',
    friendlyType: 'User Work Request Count',
    friendlyDescription: `Brings in the candidate's Work Request count`,
  },
  ServiceItemPresence: {
    type: 'ServiceItemPresence',
    friendlyType: 'Service Item Presence',
    friendlyDescription: 'Brings in the presence of one or more service items',
  },
}
